import { useEffect, useState } from "react";
import { LuEyeClosed, LuEye } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import methodModel from "../methods";
import ApiClient from "../api/apiClient";
import loader from "../loader";
import { login_success } from "../../actions/user";
import { useDispatch, useSelector } from "react-redux";

export default function Login() {
  const user = useSelector((state) => state.user);
  const [form, setForm] = useState({
    email: "",
    password: "",
    remember: false,
  });
  const [eye, setEye] = useState(false);
  const [submitted, setsubmitted] = useState(false);
  const history = useNavigate();
  const dispatch = useDispatch();
  const isValidEmail = form?.email?.trim()
    ? methodModel.emailvalidation(form.email.trim())
    : false;

  useEffect(() => {
    if (user && user?._id) {
      history("/products");
    }
    const r = localStorage.getItem("remember");
    if (r) {
      try {
        const data = JSON.parse(r);
        setForm((prev) => ({
          ...prev,
          email: data.email || "",
          password: data.password || "",
          remember: true,
        }));
      } catch (err) {
        console.error(err);
      }
    }

    const id = methodModel.getPrams("id");
    if (id) {
      ApiClient.post("user/auto/login", { id }).then((res) => {
        if (res.success) localStorage.setItem("token", res?.data?.access_token);
        dispatch(login_success(res?.data));
        if (res?.data?.isLoggedinOnce) {
          history("/products");
        } else {
          if (res?.data?.from_admin_side) {
            history("/create-password");
          } else {
            history("/products");
          }
        }
      });
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setsubmitted(true);

    if (!form.email?.trim() || !isValidEmail || !form.password) {
      return;
    }

    let payload = {
      email: form.email.trim(),
      password: form.password,
    };

    loader(true);
    ApiClient.post(`user/login`, payload)
      .then((res) => {
        if (res.success) {
          if (form?.remember) {
            localStorage.setItem(
              "remember",
              JSON.stringify({
                email: form.email.trim(),
                password: form.password,
              }),
            );
          } else {
            localStorage.removeItem("remember");
          }
          localStorage.setItem("token", res?.data?.access_token);
          dispatch(login_success(res?.data));
          history("/products");
        }
      })
      .catch((err) => {
        console.error("Login error:", err);
      })
      .finally(() => {
        loader(false);
      });
  };

  return (
    <>
      <div
        className="h-screen overflow-auto flex !bg-bottom !bg-cover !bg-no-repeat p-5"
        style={{ background: "url('assets/img/auth-bg.webp')" }}
      >
        <div className="w-full m-auto">
          <div className="auth-page grid grid-cols-12 gap-3 max-w-[500px] md:max-w-[900px] w-full rounded-[20px] bg-white sm:px-10 p-5 py-10 mx-auto relative">
            <div className="col-span-5 max-md:hidden">
              <div className="flex flex-col gap-y-[6rem] justify-between h-full">
                <Link to="/">
                  <img
                    src="/assets/img/logo.png"
                    className="w-[120px] md:w-[120px] object-contain cursor-pointer mx-auto"
                    alt="Logo"
                  />
                </Link>
                <div className="relative top-[10px]">
                  <img
                    src="/assets/img/auth-left-img.png"
                    className="w-full h-full object-contain scale-[1.6]"
                    alt="Auth illustration"
                  />
                </div>
              </div>
            </div>
            <div className="col-span-12 md:col-span-7 flex h-full items-center md:ml-[4rem] z-10">
              <form onSubmit={handleSubmit} noValidate className="w-full">
                <div className="space-y-3">
                  <img
                    src="/assets/img/circle-2.png"
                    className="w-[125px] h-[125px] object-contain absolute right-5 top-0"
                    alt="Decoration"
                  />
                  <img
                    src="/assets/img/logo.png"
                    className="w-[120px] md:w-[120px] object-contain cursor-pointer mx-auto md:hidden"
                    alt="Logo"
                  />
                  <h2 className="text-[#115B9D] text-3xl font-semibold text-center">
                    Welcome Back
                  </h2>
                  <div className="space-y-1">
                    <h3 className="text-2xl text-[#414141] text-center font-semibold">
                      Login
                    </h3>
                    <p className="text-sm text-center text-[#737373]">
                      Please enter your details
                    </p>
                  </div>
                </div>

                <div className="space-y-4 mt-7">
                  {/* Email Address */}
                  <div className="w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type="email"
                        placeholder="name@example.com"
                        value={form?.email}
                        onChange={(e) =>
                          setForm({ ...form, email: e.target.value })
                        }
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4"
                      />
                    </div>
                    {submitted && !form?.email?.trim() && (
                      <span
                        role="alert"
                        className="text-xs text-[#c53030] mt-1 block"
                      >
                        Email address is required
                      </span>
                    )}
                    {submitted && form?.email?.trim() && !isValidEmail && (
                      <span
                        role="alert"
                        className="text-xs text-[#c53030] mt-1 block"
                      >
                        Please enter a valid email address
                      </span>
                    )}
                  </div>

                  {/* Password */}
                  <div className="w-full space-y-1">
                    <label className="text-sm font-[400] text-[#737373]">
                      Password <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type={eye ? "text" : "password"}
                        placeholder="••••••••"
                        value={form?.password}
                        onChange={(e) =>
                          setForm({ ...form, password: e.target.value })
                        }
                        className="border !outline-none h-11 rounded-[12px] w-full text-[12px] pl-4 pr-[44px]"
                      />
                      {eye ? (
                        <LuEye
                          onClick={() => setEye(!eye)}
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      ) : (
                        <LuEyeClosed
                          onClick={() => setEye(!eye)}
                          className="text-[#737373] absolute top-[0px] right-[0px] w-[44px] h-[44px] p-[12px] cursor-pointer hover:opacity-70"
                        />
                      )}
                    </div>
                    {submitted && !form?.password && (
                      <span
                        role="alert"
                        className="text-xs text-[#c53030] mt-1 block"
                      >
                        Password is required
                      </span>
                    )}
                  </div>
                </div>

                <div className="flex justify-between gap-3 mt-3">
                  <div className="flex justify-between gap-2">
                    <input
                      type="checkbox"
                      checked={form?.remember}
                      onChange={(e) =>
                        setForm({ ...form, remember: e.target.checked })
                      }
                      className="w-5 h-5 border-gray cursor-pointer"
                    />
                    <p className="text-sm text-[#737373] cursor-pointer hover:opacity-80">
                      Remember me
                    </p>
                  </div>
                  <Link
                    to="/forgotpassword"
                    className="text-sm font-semibold text-[#115B9D] cursor-pointer hover:opacity-80"
                  >
                    Forgot Password?
                  </Link>
                </div>

                <div className="mt-8">
                  <button
                    type="submit"
                    className="bg-[linear-gradient(45deg,#115B9D,#062037)] w-full text-sm font-[600] text-white h-11 flex items-center justify-center gap-2 rounded-[12px] shadow-btn hover:opacity-80 transition-all focus:ring-2 ring-[#EDEBFC] disabled:bg-[#D0CAF6] disabled:cursor-not-allowed !px-4 cursor-pointer"
                  >
                    Login
                  </button>
                </div>

                <div className="flex gap-1 justify-center mt-5">
                  <p className="text-sm text-[#737373]">Don’t have account?</p>
                  <Link
                    to="/signup"
                    className="text-sm font-semibold text-[#115B9D] cursor-pointer hover:opacity-80"
                  >
                    Signup
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
